module.exports = __webpack_public_path__ + "img/archive-blue.e2c279c5.svg";